import { NotifyService } from '@/services/notify/notify_service'
import { AxiosResponse } from '@/types';
import { SearchParams } from '@/types/good_table_types'

export default class TestReportNotifyService extends NotifyService {

  /**
   * テスト結果閲覧依頼（全ユーザー）
   *
   * @aparam params
   */
  public notifyAll(param: SearchParams): Promise<AxiosResponse> {
    return this.getReq('/api/v1/checktest_report_notify_all', param) as Promise<AxiosResponse>;
  }

  /**
   * テスト結果閲覧依頼（指定ユーザー）
   *
   * @aparam params
   */
  public notifyTarget(userIds: number[]): Promise<AxiosResponse> {
    return this.getReq('/api/v1/checktest_report_notify', {'userIds': userIds}) as Promise<AxiosResponse>;
  }

}

